/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FORM : FIELD : TEXT : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    searchbar: {
        height: pxToEm(48),
        padding: replacePXinStringWithEM(`0 ${pxToEm(10)}`),
        margin: '0',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'flex-start',
        position: 'relative',
        zIndex: '2',
        transition: theme.animation.general('all'),
        border: replacePXinStringWithEM(`1px solid transparent`),
        background: theme.color.supporting.light.swatch,
        color: theme.color.neutral.dark.swatch,
        '& .icon': {
            width: pxToEm(30),
            height: pxToEm(50),
            display: 'flex',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'flex-start'
        },
        '& .element': {
            flex: '1',
            '& input': {
                backgroundColor: 'transparent',
                border: '0',
                color: 'inherit',
                fontSize: pxToEm(16),
                width: '100%',
                height: pxToEm(50),
                margin: '0',
                padding: '0',
                outline: 'none',
                '&::placeholder': {
                    color: theme.color.supporting.dark.swatch,
                    opacity: '.4'
                }
            }
        },
        '&:hover': {
            filter: 'brightness(97%)'
        }
    }
});